import React from 'react';
import { useUser } from '../../contexts/UserContext'; // adjust the path if different
import { Spinner } from 'react-bootstrap';

const SubscriptionStatus = () => {
  const { user, loading } = useUser();

  if (loading) {
    return (
      <div className="d-flex justify-content-center my-4">
        <Spinner animation="border" role="status" />
      </div>
    );
  }

  if (!user) {
    return (
      <div className="alert alert-warning text-center mt-4">
        Please log in to view your subscription status.
      </div>
    );
  }

  const isPremium = user.premium === 1;

  return (
    <div className="card shadow-sm my-4 mx-auto" style={{ maxWidth: '400px' }}>
      <div className="card-body text-center">
        <h5 className="card-title mb-3">Subscription Plan</h5>
        <span className={`badge ${isPremium ? 'bg-success' : 'bg-secondary'} fs-6`}>
          {isPremium ? 'Premium User' : 'Free Plan'}
        </span>
        <p className="mt-3 mb-0 text-muted">
          {isPremium
            ? 'Thank you for being a premium member!'
            : 'You are currently on the free plan.'}
        </p>
      </div>
    </div>
  );
};

export default SubscriptionStatus;
